import { Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreBooking, type CoreCustomer } from '@flecto/types'
import {
  DataTable,
  type DataTableColumn,
  type DataTableProps,
} from '@flecto/ui'

import { TextCustomerContacts } from '../../../customers'
import { CellActions } from './CellActions'
import { CellName } from './CellName'

export type TableBookingCustomerProps = Omit<
  DataTableProps<CoreCustomer>,
  'columns'
> & {
  booking?: CoreBooking
  customer?: CoreCustomer
}

export function TableBookingCustomer({
  booking,
  customer,
  ...props
}: TableBookingCustomerProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_customer' })

  const columns: DataTableColumn<CoreCustomer>[] = [
    {
      accessor: 'full_name',
      width: 250,
      title: t('label_customer_name'),
      render: (row) => <CellName customer={row} />,
    },
    {
      accessor: 'contacts',
      title: t('label_customer_contacts'),
      render: (row) => <TextCustomerContacts customer={row} />,
    },
    {
      accessor: 'vat_number',
      title: t('label_customer_vat_number'),
      render: (row) => <Text>{row.vat_number ?? '-'}</Text>,
    },
    {
      accessor: 'actions',
      title: '',
      render: (row) => <CellActions customer={row} booking={booking} />,
    },
  ]

  return (
    <DataTable
      {...props}
      columns={columns}
      records={customer ? [customer] : []}
    />
  )
}
